import { ACCOUNT_ID } from 'hooks';
import { getAbsoluteAssetLink } from '../../InternalLink/utils/getAbsoluteAssetLink';

export const getYahooWrapperLink = accountId =>
    getAbsoluteAssetLink(
        `/html/parent-app-demo-index.html?TA_URL=${encodeURIComponent(
            `${window.location.origin}?${ACCOUNT_ID}=${accountId}&parentHost=${window.origin}`
        )}`
    );
